import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } };

  submit() {
    this.element.requestSubmit();
  }

  debounce() {
    clearTimeout(this.#timer);

    this.#timer = setTimeout(() => this.submit(), this.delayValue);
  }

  #timer = null;
}
